import React from 'react'
import './Header2.css'
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';
import inmar from './Imagenes/inmar.png'
import Sidebar from './Sidebar';

function Header() {
    const[{basket, user },dispatch]= useStateValue();

    const handleAuthentication = () => {
        if (user) {
        auth.signOut();
        }
    }
    return (
        <div className='header'>
            <Link to="/">
            <img className="header_logo"
           src= {inmar} />
        </Link>
        <div className="header_search">
            <input className= "header_searchInput" type="text"/>
            <SearchIcon 
            className="header_searchIcon"/>
        </div>
        <div className= "header_nav">
            <Link style={{ textDecoration: 'none' }} to={!user && '/login'}>
           <div onClick={handleAuthentication}className= "header_option">
           <span className= "header_optionLineOne">
               {!user ? 'Invitado' : user.email} </span>
               <span className= "header_optionLineTwo">
               {user ? 'Cerrar sesión': 'Iniciar sesión'} </span>
           </div> 
           </Link>
           
           <Link style={{ textDecoration: 'none' }} to='/orders'>
           <div className= "header_option">
           <span className= "header_optionLineOne">
               Pedidos </span>
               <span className= "header_optionLineTwo">
               Ordenes </span>
           </div> 
           </Link>
           <Link style={{ textDecoration: 'none' }} to="/Lista">
           <div className= "header_option">
           <span className= "header_optionLineOne">
               Nuestro</span>
               <span className= "header_optionLineTwo">
               Catálogo</span>
           </div> 
           </Link>
           <Link style={{ textDecoration: 'none' }} to="/checkout">
        <div className="header_optionBasket">
            <ShoppingCartIcon style={{ fontSize: 36 }}/>
            <span className= "header_optionLineTwo header_basketCount">
                {basket?.length}
            </span>
        </div>
        </Link>

        </div>
        <Sidebar />
        </div>
    )
}

export default Header
